import '../styles/pages/club-card-user-page.scss'

import React, { useEffect } from 'react'

import Spinner from '../assets/SpinnerIcon'
import { Coupons } from '../components/ClubCard/Coupons'
import { BannerIntro } from '../components/ClubCard/User/BannerIntro'
import { HistoryPointsWrapper } from '../components/ClubCard/User/HistoryPointsWrapper'
import { Offers } from '../components/ClubCard/User/Offers'
import { PointsBalance } from '../components/ClubCard/User/PointsBalance'
import { PointsWrapper } from '../components/ClubCard/User/PointsWrapper'
import { Shortcuts } from '../components/ClubCard/User/Shortcuts'
import { Vouchers } from '../components/ClubCard/Vouchers'
import { WebviewLogout } from '../components/ClubCard/WebviewLogout'
import { Banner } from '../components/sections/Banner'
import { useCardContext } from '../contexts/CardContext'
import { useClubContext } from '../contexts/ClubContext'
import { useStoreContext } from '../contexts/StoreContext'
import { goToBenefitsClubCardPlus, goToLogin } from '../utils/navigation'

import type { ClubCardUserPageSectionData } from '../types/ClubCard/ClubCardUser'

interface ClubCardUserPageProps {
  data: ClubCardUserPageSectionData
}

export function ClubCardUserPage({ data }: ClubCardUserPageProps) {
  const { loginUrl } = useStoreContext()
  const { isLoading, userInfos } = useClubContext()
  const {
    balance,
    getBalance,
    pointsUrl,
    getPointsUrl,
    historyPoints: historyPointsData,
    getHistoryPoints,
  } = useCardContext()

  const {
    shortcuts,
    pointsBalance,
    desktopBanner,
    intro,
    offers,
    marketingBanner,
    coupons,
    points,
    historyPoints,
    vouchers,
  } = data

  const bannerDesktop = {
    ...desktopBanner,
    mobile: desktopBanner?.desktop,
  }

  useEffect(() => {
    if (isLoading) {
      return
    }

    if (!userInfos?.id) {
      goToLogin(loginUrl, window?.location?.pathname + window?.location?.search)

      return
    }

    if (!userInfos?.isCartonist) {
      goToBenefitsClubCardPlus()
    }
  }, [isLoading, userInfos])

  useEffect(() => {
    async function fetchCardInfos() {
      // Prevent requests if already has data
      const getBalanceRequest = balance?.data ? undefined : getBalance
      const getPointsUrlRequest = pointsUrl?.data ? undefined : getPointsUrl
      const getHistoryPointsRequest = historyPointsData?.data
        ? undefined
        : getHistoryPoints

      await Promise.all([
        getBalanceRequest?.(),
        getPointsUrlRequest?.(),
        getHistoryPointsRequest?.({}),
      ])
    }

    fetchCardInfos()
  }, [])

  if (isLoading || !userInfos?.isCartonist) {
    return (
      <div className="club-card-user-page-loader">
        <Spinner color="var(--loyalty-color-surface-strong)" />
      </div>
    )
  }

  return (
    <div className="club-card-user-page-container">
      <div className="club-card-user-shortcut-container grid-content">
        <div className="club-card-user-shortcut-infos">
          <Shortcuts {...shortcuts} location="cartonista" isInline />
          <PointsBalance {...pointsBalance} />
        </div>
        <Banner
          data={bannerDesktop}
          className="club-card-user-shortcutBanner"
        />
      </div>
      <BannerIntro {...intro} />
      <Offers {...offers} />
      <Banner data={marketingBanner} />
      <Coupons {...coupons} />
      <HistoryPointsWrapper {...historyPoints} />
      <PointsWrapper {...points} />
      <Vouchers {...vouchers} />
      <WebviewLogout />
    </div>
  )
}
